import { BenchmarkDto } from "@modules/benchmark/api/benchmarkDto"
import { BenchmarkCategories, BenchmarkCategory, BenchmarkTypeOf } from "@modules/benchmark/benchmarkTypes"
import { Chrono } from "@modules/chrono/chronoTypes"
import { convertChronoFromDto } from "@modules/chrono/services/chronoDtos"
import { convertToType } from "@modules/utils/enum"

export class BenchmarkEntity {
  id: string
  title: string
  description: string
  _type: typeof BenchmarkTypeOf
  category: BenchmarkCategory
  chrono?: Chrono
  isFavorite: boolean

  constructor(benchmark: BenchmarkEntity) {
    this.id = benchmark.id
    this.title = benchmark.title
    this.description = benchmark.description
    this._type = benchmark._type
    this.category = benchmark.category
    this.isFavorite = false
    this.chrono = benchmark.chrono
  }

  static fromDto(dto: BenchmarkDto): BenchmarkEntity {
    return new BenchmarkEntity({
      ...dto,
      _type: BenchmarkTypeOf,
      category: convertToType(BenchmarkCategories, dto.category, BenchmarkCategories[0]),
      chrono: dto.chrono ? convertChronoFromDto(dto.chrono) : undefined,
    })
  }
}
